import type { FilterGroup, ViewFilter } from '../models'

export function isFilterGroup(item: ViewFilter | FilterGroup): item is FilterGroup {
  return 'conjunction' in item && 'conditions' in item
}

export function emptyFilterGroup(): FilterGroup {
  return { conjunction: 'AND', conditions: [] }
}

export function countFilterLeaves(group: FilterGroup): number {
  let count = 0
  for (const condition of group.conditions) {
    count += isFilterGroup(condition) ? countFilterLeaves(condition) : 1
  }
  return count
}
